import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAnalyticsService } from 'services/analyticsService';

import { useKioskManager } from './useKioskManager';
import { useKioskParams } from './useKioskParams';

export const useLetsGo = (id: number) => {
  const analyticsService = useMemo(() => getAnalyticsService(), []);
  const navigate = useNavigate();
  const { kioskMode, kioskRegistration } = useKioskManager();
  const { id: kioskId, model: kioskModel } = useKioskParams() || {};

  return () => {
    analyticsService.track(analyticsService.events.SetDestination, {
      destinationId: id,
    });
    if (kioskMode && kioskRegistration) {
      navigate(
        `/campus-navigation?kioskId=${kioskId}&kioskModel=${kioskModel}&destinationid=${id}`,
      );
    } else {
      const params = new URLSearchParams(window.location.search);
      params.set('destinationid', `${id}`);

      navigate(`/campus-navigation?${params.toString()}`);
    }
  };
};
